import React, {memo, useState, useCallback} from "react"
import {PasswordContainer} from "../../../../../components/PasswordContainer"
import {useHistory} from "react-router-dom"
import "./index.scss"

export const TouchTestScreen = memo(function TouchTestScreen() {
    const history = useHistory()
    const [selected, setSelected] = useState(Array(756).fill("white"))
    const onClickSelected = useCallback(
        (index: number) => {
            if (index !== null) {
                const newCircles = [...selected]
                newCircles[index] = "rgb(0, 255, 0)"
                setSelected(newCircles)
            }
        },
        [selected]
    )
    const touchMove = useCallback(
        (e: any) => {
            const touching = e.touches[0]
            const element = document.elementFromPoint(touching.clientX, touching.clientY)
            const index = parseInt(element.getAttribute("data-indeks"))

            if (index !== null) {
                const newCircles = [...selected]
                newCircles[index] = "rgb(0, 255, 0)"
                setSelected(newCircles)
            }
        },
        [selected]
    )
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <div
                className="touch-test-container"
                onDoubleClick={() => history.push("/settings/advanced-settings/test")}
                style={{touchAction: "none"}}
                onTouchMove={touchMove}
            >
                {selected.map((color, index) => (
                    <span
                        key={index}
                        onClick={() => onClickSelected(index)}
                        style={{backgroundColor: color}}
                        data-indeks={index}
                    />
                ))}
            </div>
        </PasswordContainer>
    )
})
